import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

class Default extends PureComponent {
  render() {
    return <div>{this.props.children}</div>
  }
}

Default.propTypes = {
  children: PropTypes.node.isRequired
}

export default Default
